import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { getProductBySku } from '@app/api/Product';

@Injectable({ providedIn: 'root' })
export class ResolveProductGuardService {
	private readonly router = inject(Router);

	async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
		const sku = route.paramMap.get('sku');
		try {
			const { data: product } = await getProductBySku(sku);
			if (!product?.id) throw new Error('product not found');
			return this.router.createUrlTree(['/product', product.id]);
		} catch {
			return this.router.createUrlTree(['/product', 'not-found', sku]);
		}
	}
}
